<template>
  <div class="wrapper">
    <div class="gitex-photo-report">
      <div class="grid-box">
        <div class="grid-box-info">
          <div class="grid-box-info__title">
            {{ $t('dfAtGitex') }}
          </div>
          <div class="grid-box-info__description">
            {{ $t('gitexReport') }}
          </div>
          <div class="grid-box-info__btns" dir="ltr">
            <div
              class="button"
              @click="swiperInstanceGrid?.slidePrev()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.724 5.04152L7.05736 11.4052C6.71447 11.7325 6.71447 12.2671 7.05736 12.5945L13.724 18.9581C14.0617 19.2804 14.6054 19.2804 14.943 18.9581C15.2859 18.6308 15.2859 18.0961 14.943 17.7688L8.89933 11.9998L14.943 6.23082C15.2859 5.90351 15.2859 5.36882 14.943 5.04152C14.6054 4.71923 14.0617 4.71923 13.724 5.04152Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              class="button"
              @click="swiperInstanceGrid?.slideNext()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.276 18.9585L16.9426 12.5948C17.2855 12.2675 17.2855 11.7329 16.9426 11.4055L10.276 5.04191C9.93834 4.71962 9.39461 4.71962 9.05697 5.04191C8.71408 5.36922 8.71408 5.9039 9.05697 6.23121L15.1007 12.0002L9.05697 17.7692C8.71408 18.0965 8.71408 18.6312 9.05697 18.9585C9.39461 19.2808 9.93834 19.2808 10.276 18.9585Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
          <div class="label-video" @click="showVideoModal = true">
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12ZM12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM10.916 8.37596C10.6859 8.22253 10.39 8.20823 10.1461 8.33874C9.90224 8.46926 9.75 8.7234 9.75 9V15C9.75 15.2766 9.90224 15.5307 10.1461 15.6613C10.39 15.7918 10.6859 15.7775 10.916 15.624L15.416 12.624C15.6247 12.4849 15.75 12.2508 15.75 12C15.75 11.7492 15.6247 11.5151 15.416 11.376L10.916 8.37596ZM13.6479 12L11.25 13.5986V10.4014L13.6479 12Z" fill="#E31E33" />
            </svg> -->
            <PlayCircleRed class="playCircleRed" />
            <span class="label-video-span" :class="{right}">
              {{ $t('watchVideo') }}
            </span>
          </div>
        </div>
        <div class="grid-box-main" dir="ltr">
          <swiper
            class="mySwiper"
            :pagination="{type: 'custom'}"
            :modules="modules"
            :loop="true"
            @swiper="onSwiperGrid"
          >
            <swiper-slide v-for="(photo, id) in photos" :key="id">
              <img :src="photo" alt="" @click="openModal(photo)" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div class="mobile-switcher">
      <div class="mobile-switcher-title">
        {{ $t('dfAtGitex') }}
      </div>
      <div class="mobile-switcher-description">
        {{ $t('gitexReport') }}
      </div>
      <div class="switcher-info-box" dir="ltr">
        <swiper
          class="mySwiper-mob"
          :pagination="{type: 'custom'}"
          :modules="modules"
          @pagination-update="handleSlide"
        >
          <swiper-slide v-for="(photo, idx) in photos" :key="idx">
            <div class="switcher-info-box-child">
              <div class="video-container">
                <div class="video-container__image">
                  <img :src="photo" alt="" />
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="switcher-info-box-dots" dir="ltr">
        <div
          v-for="(photo, index) in photos"
          :key="index"
          class="switcher-info-box-dots__dot"
          :class="{activeDot: index === mobileIndex}"
        />
      </div>
      <div
        class="label-video-mobile"
        @click="showMobileVideoModal = true"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12ZM12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM10.916 8.37596C10.6859 8.22253 10.39 8.20823 10.1461 8.33874C9.90224 8.46926 9.75 8.7234 9.75 9V15C9.75 15.2766 9.90224 15.5307 10.1461 15.6613C10.39 15.7918 10.6859 15.7775 10.916 15.624L15.416 12.624C15.6247 12.4849 15.75 12.2508 15.75 12C15.75 11.7492 15.6247 11.5151 15.416 11.376L10.916 8.37596ZM13.6479 12L11.25 13.5986V10.4014L13.6479 12Z"
            fill="#E31E33"
          />
        </svg>
        <span class="label-video-span-mobile">{{
          $t('watchVideo')
        }}</span>
      </div>
    </div>
    <ui-modal v-model="showModal">
      <img class="fullscreen-image" :src="imageSrc" alt="" />
    </ui-modal>
    <ui-modal v-model="showVideoModal">
      <video class="fullscreen-video" controls autoplay>
        <source
          :src="`${staticUrl}/video/DreamFlat-Gitex.mp4`"
          type="video/mp4"
        />
      </video>
    </ui-modal>
    <ui-modal v-model="showMobileVideoModal">
      <video class="fullscreen-video-mobile" controls autoplay>
        <source
          :src="`${staticUrl}/video/DreamFlat-Gitex.mp4`"
          type="video/mp4"
        />
      </video>
    </ui-modal>
  </div>
</template>

<script lang="ts" setup>
import {Swiper, SwiperSlide} from 'swiper/vue';
import {EffectCoverflow, Pagination} from 'swiper';
import PlayCircleRed from '~/assets/svg/PlayCircleRed.svg';
import 'swiper/scss';
import 'swiper/scss/pagination';
import 'swiper/scss/effect-coverflow';
import {useDirectionStore} from '~/store/direction.store';
import {useRuntimeConfig} from '#imports';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const direction = useDirectionStore();
const right = computed(() => direction.isRight);

const photos = ref([
  `${staticUrl}/images/p-gitex-photoreport-1.webp`,
  `${staticUrl}/images/p-gitex-photoreport-2.webp`,
  `${staticUrl}/images/p-gitex-photoreport-3.webp`,
  `${staticUrl}/images/p-gitex-photoreport-4.webp`,
  `${staticUrl}/images/p-gitex-photoreport-5.webp`,
  `${staticUrl}/images/p-gitex-photoreport-6.webp`,
  `${staticUrl}/images/p-gitex-photoreport-7.webp`,
]);

const mobileIndex = ref(0);
const showModal = ref(false);
const showVideoModal = ref(false);
const showMobileVideoModal = ref(false);
const imageSrc = ref('');
const swiperInstanceGrid = ref();

const handleSlide = (event: any) => {
  mobileIndex.value = event.activeIndex;
};

function onSwiperGrid(instanse: any) {
  swiperInstanceGrid.value = instanse;
}

function openModal(path: string) {
  showModal.value = true;
  imageSrc.value = path;
}

const modules = [Pagination, EffectCoverflow];
</script>

<style lang="scss" scoped>
.wrapper {
  justify-content: center;
}
.playCircleRed {
  height: 32px;
  width: 32px;
  display: flex;
  #icon {
    height: 32px;
    width: 32px;
  }
}
.mySwiper {
  border-radius: 16px !important;
  height: 311px !important;
}
.mySwiper-mob {
  border-radius: 8px !important;
  height: 100% !important;
}
.mobile-switcher {
  display: none;
}

.gitex-photo-report {
  display: block;
  &__title {
    width: 1128px;
    margin: 180px auto 40px;
    color: var(--white-theme-black-100, #3d424a);
    font-family: Segoe UI;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 43.2px */
    letter-spacing: 1.08px;
  }
  &__description {
    width: 1128px;
    margin: 0 auto 40px;
    & > span {
      display: block;
      width: 552px;
      color: var(--white-theme-black-100, #3d424a);
      font-family: Segoe UI;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 22.4px */
      letter-spacing: 0.48px;
    }
  }
}
@media (max-width: $lg) {
  .gitex-photo-report {
    display: none;
  }

  .mobile-switcher {
    margin: 128px auto 0;
    display: block;
    padding: 0 16px;
    width: 100%;
    min-height: 430px;
    // overflow: hidden;
    display: flex;
    flex-direction: column;

    &-title {
      color: var(--white-theme-black-100, #3d424a);
      font-family: Segoe UI;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%; /* 28.8px */
      letter-spacing: 0.72px;
    }
    &-description {
      margin: 17px 0;
      width: 100%;
      color: var(--white-theme-black-100, #3d424a);
      font-family: Segoe UI;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 21px */
      letter-spacing: 0.45px;
    }
    .switcher-info-box-dots {
      margin: 10px auto 0;
      width: auto;
      height: 8.67px;
      display: flex;
      gap: 5.79px;
      &__dot {
        background: #b2c0cd;
        width: 8.67px;
        height: 8.67px;
        border-radius: 50%;
      }
      &__dot.activeDot {
        background-color: #e31e33;
      }
    }
    .label-video-mobile {
      margin: 20px auto 0;
      display: flex;
      gap: 11px;
      align-items: center;
      .label-video-span-mobile {
        color: #e31e33;
        text-align: center;
        font-family: Segoe UI;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0.28px;
      }
    }
    .switcher-info-box {
      width: 100%;
      position: relative;
    }

    .video-container {
      &__image {
        width: 100%;

        img {
          display: block;
          width: 100%;
          border-radius: 8px;
        }
      }

      &__video {
        width: 100%;

        video {
          width: 100%;
          border-radius: 8px;
        }
      }
    }

    @media (max-width: $md) {
      margin: $m-5 auto 0;
    }
  }
}

.fullscreen-image {
  width: 1240px;
  height: 700px;
  border-radius: 32px;
}
.fullscreen-video {
  max-width: 1240px;
  height: 700px;
  flex: 0 1 0;
  // border-radius: 32px;
}
.fullscreen-video-mobile {
  width: 100%;
}

.grid-box {
  margin: 180px auto;
  display: flex;
  gap: 24px;
  width: 1128px;
  height: 311px;
  @media (max-width: 1160px) {
    width: 1024px;
  }
  &-info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: calc((100% - 24px) / 2);
    &__title {
      color: var(--white-theme-black-100, #3d424a);
      font-family: Segoe UI;
      font-size: 36px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%; /* 43.2px */
      letter-spacing: 1.08px;
    }
    &__description {
      width: 100%;
      color: var(--white-theme-black-100, #3d424a);
      font-family: Segoe UI;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 22.4px */
      letter-spacing: 0.48px;
    }
    &__btns {
      margin-top: 16px;
      display: flex;
      gap: 16px;
      width: 96px;
      height: 40px;
      .button {
        height: 40px;
        width: 40px;
        padding: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        background: #e31e33;
        cursor: pointer;
      }
    }
    .label-video {
      margin-top: 16px;
      display: flex;
      gap: 11px;
      align-items: center;
      cursor: pointer;
      user-select: none;
      position: relative;
      &-span {
        display: inline-block;
        align-self: center;
        height: 19px;
        // width: 82px;
        color: #e31e33;
        text-align: center;
        font-family: Segoe UI;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0.28px;
        &.right {
          left: auto;
          right: 0;
          transform: translateX(-40%);
        }
      }
    }
  }
  &-main {
    height: 311px;
    width: 552px;
    border-radius: 16px;
    img {
      height: 100%;
      width: 100%;
      border-radius: 16px;
    }
  }
}
</style>
